<template>
  <div>
    <v-card>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
    <v-card>
      <div  id='stiff'>
    <svg id='svgVWC' height='460px'/>
          </div>
    </v-card>
    </v-flex>
    <v-flex xs12>
    <v-card>
      <v-card-text>
    <v-slider v-model='sliderStart' label='From'></v-slider>
      {{startDateString}}
    </v-card-text>
    <v-card-text>
    <v-slider v-model='sliderEnd' label='  To'></v-slider>
      {{endDateString}}
    </v-card-text>
    </v-card>
    </v-flex>
  </v-layout>
    </v-container>
    </v-card>
  </div>
</template>
<script>
import {db} from '../../firebase/firebase'
import * as d3 from 'd3'
import {svgResizer} from '../mixins/svgResizer'
var timeParse = d3.utcParse('%Y-%m-%dT%H:%M:%S')
export default {
  mixins: [svgResizer],
  data () {
    return {
      dataBegin: 0,
      dataEnd: 0,
      clientWidth: 500,
      clientHeight: 460,
      sliderStart: 0,
      sliderEnd: 100,
      start: 0,
      end: 0,
      sampleCount: 200,
      samples: [],
      samplesFetched: 0
    }
  },
  mounted () {
    //  this.$set(this.samples, 40, 100)
    this.fetchRange()
    this.fetchnSamples()
  },
  computed: {
    range: function () {
      return this.end - this.start
    },
    step: function () {
      return this.range / this.sampleCount
    },
    startDateString: function () {
      return new Date((this.start - (25567 + 1)) * 86400 * 1000).toLocaleString()
    },
    endDateString: function () {
      return new Date((this.end - (25567 + 1)) * 86400 * 1000).toLocaleString()
    }
  },
  watch: {
    samples: function () {
      if (this.samplesFetched >= this.sampleCount) {
        this.breakDownVisualization()
        this.setUpVisualization()
      }
    },
    range: function () {
      this.samples = []
      this.fetchnSamples()
    },
    sliderStart: function (newVal, oldVal) {
      if (newVal >= this.sliderEnd) {
        this.sliderEnd = newVal + 1
      }
      this.start = (((this.dataEnd - this.dataBegin) / 100) * newVal) + this.dataBegin
    },
    sliderEnd: function (newVal, oldVal) {
      if (newVal <= this.sliderStart) {
        this.sliderStart = newVal - 1
      }
      this.end = this.dataBegin + (((this.dataEnd - this.dataBegin) / 100) * newVal)
    }
  },
  methods: {
    setUpVisualization () {
      var margin = {top: 20, right: 20, bottom: 30, left: 50}
      var width = this.clientWidth - margin.left - margin.right
      var height = this.clientHeight - margin.top - margin.bottom

      var svg = d3.select('#svgVWC')
        .attr('width', this.clientWidth)
        .append('g')
        .attr('class', 'graph')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var x = d3.scaleTime().range([0, width])
      var y = d3.scaleLinear().range([height, 0])
// eslint-disable-next-line no-unused-vars
      var area = d3.area()
      .x(function (d) { return x(timeParse(d.date)) })
      .y0(height)
      .y1(function (d) { return y(d.temp1) })

      x.domain(d3.extent(this.samples, function (d) { return timeParse(d.date) }))
      y.domain([0, d3.max(this.samples, function (d) { return d.temp1 }) * 1.2])

      svg.append('path')
      .datum(this.samples)
      .attr('class', 'area')
      .attr('d', area)
      .attr('fill', 'mediumblue')

      svg.append('g')
      .attr('transform', 'translate(0,' + height + ')')
      .call(d3.axisBottom(x))

      svg.append('g')
      .call(d3.axisLeft(y))
    },
    breakDownVisualization () {
      d3.selectAll('.graph').remove()
      // d3.selectAll('.area').remove()
    },
    fetchRange () {
      db.ref('/projects/' + this.$route.params.projectid + '/data/decagon').orderByKey().limitToFirst(1).once('value').then(function (snapshot) {
        snapshot.forEach(function (weather) {
          this.start = parseFloat(weather.key.replace('dot', '.'))
          this.dataBegin = this.start
        }.bind(this))
      }.bind(this))
      db.ref('/projects/' + this.$route.params.projectid + '/data/decagon').orderByKey().limitToLast(1).once('value').then(function (snapshot) {
        snapshot.forEach(function (weather) {
          this.end = parseFloat(weather.key.replace('dot', '.'))
          this.dataEnd = this.end
        }.bind(this))
      }.bind(this))
    },
    fetchnSamples  (n) {
      this.samplesFetched = 0
      var that = this
      let count = 0
      for (let step = this.start; step < this.end; step += this.step) {
        let key = step.toString().replace('.', 'dot')
        db.ref('/projects/' + this.$route.params.projectid + '/data/decagon').orderByKey().endAt(key).limitToLast(1).once('value').then(function (snapshot) {
          let index = this.index
          snapshot.forEach(function (childSnapshot) {
            that.$set(that.samples, index, childSnapshot.val())
            that.samplesFetched += 1
          })
        }.bind({index: count}))
        count += 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/visualization/VolumetricWaterArea.vue